export function formatCategoryPath(categoryPath) {
    const parts = [
        categoryPath?.main?.name,
        categoryPath?.sub?.name,
        categoryPath?.subSub?.name
    ].filter(Boolean);
    return parts.join(' / ');
}

export function formatRub(n) {
    if (n === null || typeof n === 'undefined') return '';
    const v = Number(n);
    if (!Number.isFinite(v)) return '';
    return v.toLocaleString('ru-RU');
}

export function normalizeUrl(u) {
    const s = String(u || '').trim();
    if (!s) return null;
    if (/^https?:\/\//i.test(s)) return s;
    return `https://${s}`;
}

export function tryBuildRutubeEmbedUrl(rawUrl) {
    const u = normalizeUrl(rawUrl);
    if (!u) return null;
    try {
        const url = new URL(u);
        const host = url.hostname.toLowerCase();
        if (!host.endsWith('rutube.ru')) return null;

        if (/^\/play\/embed\//i.test(url.pathname)) {
            return url.toString();
        }

        const m = url.pathname.match(/^\/video\/([^/]+)\/?/i);
        if (m && m[1]) {
            const id = m[1];
            return `https://rutube.ru/play/embed/${encodeURIComponent(id)}`;
        }

        return null;
    } catch (_) {
        return null;
    }
}

function extractVkVideoParamsFromUrl(url) {
    try {
        const host = url.hostname.toLowerCase();
        if (!(host.endsWith('vk.com') || host.endsWith('vkvideo.ru') || host.endsWith('vk.ru') || host.endsWith('player.vk.com'))) {
            return null;
        }

        let candidate = url.pathname;
        if (candidate === '/video' || candidate === '/video/' || candidate === '/video.php') {
            const z = url.searchParams.get('z');
            if (z) candidate = `/${decodeURIComponent(z)}`;
        }

        const m = candidate.match(/\/video(-?\d+)_([0-9]+)/i);
        if (!m) return null;
        const oid = m[1];
        const id = m[2];
        const hash = url.searchParams.get('hash') || null;
        return { oid, id, hash };
    } catch (_) {
        return null;
    }
}

export function tryBuildVkEmbedUrl(rawUrl) {
    const u = normalizeUrl(rawUrl);
    if (!u) return null;
    try {
        const url = new URL(u);
        const p = extractVkVideoParamsFromUrl(url);
        if (!p) return null;

        const embed = new URL('https://vk.com/video_ext.php');
        embed.searchParams.set('oid', p.oid);
        embed.searchParams.set('id', p.id);
        embed.searchParams.set('hd', '2');
        if (p.hash) embed.searchParams.set('hash', p.hash);
        return embed.toString();
    } catch (_) {
        return null;
    }
}
